import { useCallback, useEffect, useState } from 'react';
import { getTerminalId } from 'modules/get-terminal-id/get-terminal-id';

export function useTerminalID() {
  const [terminalID, setTerminalID] = useState(null);

  const getTerminalID = useCallback(async () => {
    try {
      const terminalID = await getTerminalId();
      setTerminalID(terminalID);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getTerminalID();
    })();
  }, [getTerminalID]);

  return { terminalID, getTerminalID };
}
